import React from "react";
import styled from "styled-components";
import AddIconSrc from "../../../../../images/icons/add-icon.svg";
import Tabs from "../../../Components/Main/Sidebar/Tabs";
import Tab from "../../../Components/Main/Sidebar/Tab";
import TabContent from "../../../Components/Main/Sidebar/TabContent";
import MenuButton from "../../../Components/Main/Sidebar/MenuButton";
import TabContentLoading from "../../../Components/Main/Sidebar/TabContentLoading";
import AddIcon from "../../../Components/Main/Sidebar/AddIcon";
import SharedLabel from "../../../Components/Main/Sidebar/SharedLabel";
import MenuSearchInput from "../../../Components/Main/Sidebar/MenuSearchInput";
import api from '../../../../util/api';
import ModalOption from "../../../Components/Main/Modals/ModalOption";
import MenuSelect from "../../../Components/Main/Modals/MenuSelect";
import {ToastContainer, toast} from 'react-toastify';

import ThreeDotMenuIcon from "../../../../../images/icons/3-dot-menu-icon.png";
import SelectedStarIcon from "../../../../../images/icons/selected-star-icon.png";
import UnselectedStarIcon from "../../../../../images/icons/unselected-star-icon.png";

const Pagination = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding-bottom: 20px;
    background: white;
    padding-top: 20px;
    .pagination-pages > span:not(.visible) {
        display: none;
    }
`;

const PaginationRefresh = styled.a`
    text-decoration: underline;
    text-align: center;
    width: 100%;
    display: block;
    font-size: 14px;
    color: #888888;
    cursor: pointer;
`;

const Pages = styled.div`
    text-align: center;
    margin-top: 20px;    
`;

const PageArrow = styled.span`
    color: #888888;
    font-size: 23px;
    padding: 0 7px;
    line-height: 32px;
`;

const Page = styled.span`
    color: #888888;
    font-size: 23px;
    padding: 0 7px;
    line-height: 32px;
    cursor: pointer;
    
    ${(props) => (props.active ? {
    'background': '#5562C0',
    'color': 'white',
    'width': '30px',
    'height': '30px',
    'display': 'inline-block !important',
    'border-radius': '45px',
} : '')}
`;
const FavoriteTrigger = styled.div`
    float: right;
    height: 18px;
    position: absolute;
    top: 28px;
    right: 0;
    cursor: pointer;
    width: 20px;
    
    img {
        width: 100%;
    }
`;

const PaginationResults = styled.div`
    
    color: #888888;
    font-size: 14px;
    text-align: center;
    border-top: 1px solid lightgrey;
    padding-top: 20px;
    padding-bottom: 5px;
    margin-top: -10px;
`;

const ThreeDotMenuClose = styled.div`

    position: absolute;
    top: 6px;
    right: 6px;
    cursor: pointer;
    color: grey;
`;

const ThreeDotMenuTrigger = styled.img`
    float: right;
    height: 18px;
    position: absolute;
    top: 0;
    right: 7px;
    cursor: pointer;
`;

const SortWrapper = styled.div`
    overflow: auto; 
    width: 100%;
`;

const FileName = styled.a`
    cursor: pointer;
    font-weight: 700;
`;

const SortLabel = styled.span`   
 width: 35%;
    float: left;
    font-size: 18px;
    color: #737697;
    padding-top: 19px;
`;

const SortInputWrapper = styled.span`
width: 65%;
float: left;
`;

const ThreeDotMenu = styled.div`
    top: 0;
    right: 0;
    
    position: absolute;
    background: white; 
    border: 2px solid lightgrey;
    padding: 10px;
    box-shadow: 5px 5px 25px #0000002e;
    display: none;   
    z-index: 9;
   
    
    
    ${(props) => (props.open ? {
    'display': 'block'
} : '')}
`;

const ThreeDotMenuItem = styled.div`

        display: ${(props) => (props.hidden ? "none" : "block")};
    margin-bottom: 6px;
    border-bottom: 1px solid lightgrey;
    padding-bottom: 6px;
    width: 145px;
    cursor: pointer;
    
    
    ${(props) => (props.no_border ? {
    'border': 'none !important',
    'margin': '0 !important',
    'padding': '0 !important',
} : '')}
`;

const FileMenuWrapper = styled.section`
    display: none;
    background: white;

    ${(props) =>
    props.open
        ? {
        display: "block",
    }
        : ""}
`;
const FileSubheading = styled.p`
        font-size: 12px;
    line-height: 17px;
    color: gray;
    margin-top: 6px;
    margin-bottom: 0;
`;
const FilesList = styled.div`
`;
const File = styled.div`
    border-bottom: 1px solid gray;
    padding: 21px;
    padd
        display: block;
    width: 100%;
    text-decoration: none;
    text-decoration: none;
    color: black;
    
`;
const FileHeading = styled.h3`
    font-size: 18px;
    line-height: 21px;
    margin: 0;
    padding: 0;
    position: relative;
    padding-right: 25px;
    
    min-height: 45px;
`;

const FontAwesomeIcon = styled.i`
color: #515151;
    margin-right: 15px;
    top: 1px;
    position: relative;
    cursor: pointer;
        display: ${(props) => (props.hidden ? "none" : "inline-block")};
`;

export default class FilesMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tab_open: !this.props.lesson_id || (this.props.lesson_id && !this.props.isInstructor) ? 2 : 1,
            three_dot_menu_open: null
        };
    }

    setTab(val) {
        this.setState({tab_open: val});
    }

    setThreeDotMenuOpen(val) {
        this.setState({three_dot_menu_open: val});
    }

    render() {
        return (
            <FileMenuWrapper open={this.props.open}>
                <Tabs>
                    <Tab hidden={!this.props.inLesson || (this.props.inLesson && !this.props.isInstructor)}
                         onClick={() => {
                            this.setTab(1);
                        }}
                        open={this.state.tab_open === 1}
                    >
                        {"Student Files"}
                    </Tab>
                    <Tab
                        fullwidth={!this.props.inLesson}
                        onClick={() => {
                            this.setTab(2);
                        }}
                        open={this.state.tab_open === 2}
                    >
                        {"File Library"}
                    </Tab>
                </Tabs>
                <TabContent open={this.state.tab_open === 1}>
                                             <TabContentLoading open={this.props.filesLoading}><i className="fa fa-spinner"></i></TabContentLoading>
                    <MenuButton onClick={this.props.newLessonFileAction}>
                        <AddIcon src={AddIconSrc}/>
                        {"Add File"}
                    </MenuButton>
                    <MenuSearchInput onKeyUp={this.props.searchLessonFiles} onChange={this.props.searchLessonFiles} placeholder="Search Files"></MenuSearchInput>

                   
                    <SortWrapper>
                        <SortLabel>Sort By:</SortLabel>
                        <SortInputWrapper>
                            <MenuSelect onChange={(e) => {this.props.selectSort(e, 'lessonFiles')}}>
                                <ModalOption value="created_at">Created Date</ModalOption>
                                <ModalOption value="name">Name</ModalOption>
                                <ModalOption value="favorite">Favorites</ModalOption>
                            </MenuSelect>
                        </SortInputWrapper>
                    </SortWrapper>


                    {this.props.studentPaginationMeta ? (
                        <PaginationResults>showing {this.props.lessonFiles.length} of {this.props.studentPaginationMeta ? this.props.studentPaginationMeta.total : 0} results</PaginationResults>
                    ) : (
                        <></>
                    )}
                    <FilesList>
                        {Object.keys(this.props.lessonFiles).map((item, index) => (
                            <File  key={this.props.lessonFiles[item].id}>


                                <FileHeading>
                                    <FileName target="_blank" href={this.props.lessonFiles[item].full_url}>{this.props.lessonFiles[item].name}</FileName>
                                    <ThreeDotMenuTrigger onClick={() => {this.setThreeDotMenuOpen(this.props.lessonFiles[item].id)}} src={ThreeDotMenuIcon}></ThreeDotMenuTrigger>
                                    <FavoriteTrigger onClick={(e) => {
                                            e.preventDefault();
                                            api().post('/fav', {
                                                type: 'file',
                                                item_id: this.props.lessonFiles[item].id
                                            }).then((response) => {
                                                if(response.data.success) {

                                                     toast.success(!this.props.lessonFiles[item].favorite ? 'Success! Note added to favorites!' : 'Success! Note removed from favorites!', {
                                                        position: "top-right",
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                    });
                                                    this.props.pullFiles(true, this.props.studentPaginationMeta.current_page);
                                                }
                                            });
                                        }}><img src={this.props.lessonFiles[item].favorite ? SelectedStarIcon : UnselectedStarIcon}/></FavoriteTrigger>
                                    <ThreeDotMenu open={this.state.three_dot_menu_open == this.props.lessonFiles[item].id}>
                                        <ThreeDotMenuClose onClick={() => {this.setThreeDotMenuOpen(null)}}>X</ThreeDotMenuClose>
                                        <ThreeDotMenuItem hidden={!this.props.lessonFiles[item].can_delete} onClick={(e) => {
                                e.preventDefault();
                                var r = confirm("Are you sure you want to delete the File?");
                                if (r == true) {

                                  api().delete('/files/'+this.props.lessonFiles[item].id).then((response) => {
                                    this.props.pullFiles();
                                  });
                                }
                            }} >

                                            <FontAwesomeIcon className="fas fa-trash"></FontAwesomeIcon>
                                            Delete
                                        </ThreeDotMenuItem>

                                        <ThreeDotMenuItem
                                            hidden={!this.props.lessonFiles[item].can_delete}
                                            onClick={(e) => {e.preventDefault();this.props.editFileAction(this.props.lessonFiles[item].id)}}
                                        >
                                            <FontAwesomeIcon className="fas fa-edit"></FontAwesomeIcon>
                                            Edit
                                        </ThreeDotMenuItem>


                                        <ThreeDotMenuItem
                                            no_border={true} hidden={!this.props.lessonFiles[item].can_delete}>
                                            <FontAwesomeIcon className="fas fa-share-square"
                                                             onClick={(e) => {e.preventDefault();this.props.editFileAction(this.props.lessonFiles[item].id, true)}}></FontAwesomeIcon>Share
                                        </ThreeDotMenuItem>
                                    </ThreeDotMenu>

                                    <FileSubheading>
                                        <SharedLabel
                                            full={this.props.lessonFiles[item].full_label+' - '+this.props.lessonFiles[item].created_at}
                                            short={this.props.lessonFiles[item].short_label+' - '+this.props.lessonFiles[item].created_at}>
                                        </SharedLabel>
                                    </FileSubheading>
                                </FileHeading>
                            </File>
                        ))}
                    </FilesList>



                    <Pagination>
                        {this.props.studentPaginationMeta ? (
                            <>
                            <PaginationRefresh
                                onClick={() => {this.props.pullFiles(false, this.props.studentPaginationMeta.current_page)}}>Refresh
                                results</PaginationRefresh>
                            <Pages className="pagination-pages">
                                {this.props.studentPaginationMeta.links.map((item, index) => (
                                    <>
                                    {(item.label == '...' || (index > 0 && (item.label !== '<' && item.label !== '>' && index <= item.label))) ? (
                                        <span index={index}
                                              className={this.props.studentPaginationMeta.current_page - 1 == item.label || this.props.studentPaginationMeta.current_page + 1 == item.label || item.active || item.label == '...' || index == 0 || index == 1 || index == 2 || item.label == this.props.studentPaginationMeta.last_page || item.label == this.props.studentPaginationMeta.last_page - 1 || item.label == this.props.studentPaginationMeta.last_page - 2 ? 'visible pagination-page-wrapper' : 'pagination-page-wrapper'}
                                              key={index}>
                                        <Page className="pagination-page"
                                              onClick={() => {this.props.pullFiles(false, item.label);}}
                                              active={item.active}>{item.label}</Page>
                                        </span>
                                    ) : (
                                        <>
                                        {(index == 0) ? (


                                            <span index={index}
                                                  className={'visible pagination-page-wrapper'}
                                                  key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullFiles(false, this.props.studentPaginationMeta.current_page == 1 ? 1 : this.props.studentPaginationMeta.current_page - 1);}}>
                                                {"<"}
                                            </PageArrow>
                                            </span>
                                        ) : (

                                            <span index={index}
                                                  className={'visible pagination-page-wrapper'}
                                                  key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullFiles(false, this.props.studentPaginationMeta.current_page == this.props.studentPaginationMeta.last_page ? this.props.studentPaginationMeta.last_page : this.props.studentPaginationMeta.current_page + 1);}}>
                                                {">"}
                                            </PageArrow>
                                            </span>
                                        )}
                                        </>
                                    )}
                                    </>
                                ))}
                            </Pages>
                            </>
                        ) : (
                            <></>
                        )}
                    </Pagination>
                </TabContent>
                <TabContent open={this.state.tab_open === 2}>
                                             <TabContentLoading open={this.props.filesLoading}><i className="fa fa-spinner"></i></TabContentLoading>
                    <MenuButton onClick={this.props.newFileAction}>
                        <AddIcon src={AddIconSrc}/>
                        {"Add File"}
                    </MenuButton>
                    <MenuSearchInput onKeyDown={this.props.searchMyFiles} onChange={this.props.searchMyFiles} placeholder="Search Files"></MenuSearchInput>

                    <SortWrapper>
                        <SortLabel>Sort By:</SortLabel>
                        <SortInputWrapper>
                            <MenuSelect onChange={(e) => {this.props.selectSort(e, 'myFiles')}}>
                                <ModalOption value="created_at">Created Date</ModalOption>
                                <ModalOption value="name">Name</ModalOption>
                                <ModalOption value="favorite">Favorites</ModalOption>
                            </MenuSelect>
                        </SortInputWrapper>
                    </SortWrapper>
                    {this.props.paginationMeta ? (
                        <PaginationResults>showing {this.props.yourFiles.length} of {this.props.paginationMeta ? this.props.paginationMeta.total : 0} results</PaginationResults>
                    ) : (
                        <></>
                    )}
                    <FilesList>
                        {Object.keys(this.props.yourFiles).map((item, index) => (
                            <File  key={this.props.yourFiles[item].id}>


                                <FileHeading>
                                    <FileName target="_blank" href={this.props.yourFiles[item].full_url}>{this.props.yourFiles[item].name}</FileName>
                                    <ThreeDotMenuTrigger onClick={() => {this.setThreeDotMenuOpen(this.props.yourFiles[item].id)}} src={ThreeDotMenuIcon}></ThreeDotMenuTrigger>
                                    <FavoriteTrigger onClick={(e) => {
                                            e.preventDefault();
                                            api().post('/fav', {
                                                type: 'file',
                                                item_id: this.props.yourFiles[item].id
                                            }).then((response) => {
                                                if(response.data.success) {
                                                
                                                     toast.success(!this.props.yourFiles[item].favorite ? 'Success! File added to favorites!' : 'Success! File removed from favorites!', {
                                                        position: "top-right",
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                    });
                                                    // this.props.yourFiles[item].favorite = !this.props.yourFiles[item].favorite;
                                                    this.props.pullFiles(false, this.props.paginationMeta.current_page);
                                                }
                                            });
                                        }}><img src={this.props.yourFiles[item].favorite ? SelectedStarIcon : UnselectedStarIcon}/></FavoriteTrigger>
                                    <ThreeDotMenu open={this.state.three_dot_menu_open == this.props.yourFiles[item].id}>
                                        <ThreeDotMenuClose onClick={() => {this.setThreeDotMenuOpen(null)}}>X</ThreeDotMenuClose>

                                        <ThreeDotMenuItem hidden={!this.props.yourFiles[item].can_delete} onClick={(e) => {
                                e.preventDefault();
                                var r = confirm("Are you sure you want to delete the File?");
                                if (r == true) {

                                  api().delete('/files/'+this.props.yourFiles[item].id).then((response) => {
                                    this.props.pullFiles(false, this.props.paginationMeta.current_page);
                                  });
                                }
                            }} >

                                            <FontAwesomeIcon className="fas fa-trash"></FontAwesomeIcon>
                                            Delete
                                        </ThreeDotMenuItem>

                                        <ThreeDotMenuItem
                                            hidden={!this.props.yourFiles[item].can_delete}
                                            onClick={(e) => {e.preventDefault();this.props.editFileAction(this.props.lessonFiles[item].id)}}
                                        >
                                            <FontAwesomeIcon className="fas fa-edit"></FontAwesomeIcon>
                                            Edit
                                        </ThreeDotMenuItem>


                                        <ThreeDotMenuItem
                                            no_border={true} hidden={!this.props.yourFiles[item].can_delete}>
                                            <FontAwesomeIcon className="fas fa-share-square"
                                                             onClick={(e) => {e.preventDefault();this.props.editFileAction(this.props.yourFiles[item].id), true}}></FontAwesomeIcon>Share
                                        </ThreeDotMenuItem>

                                    </ThreeDotMenu>

                                    <FileSubheading>
                                        <SharedLabel
                                            full={this.props.yourFiles[item].full_label+' - '+this.props.yourFiles[item].created_at}
                                            short={this.props.yourFiles[item].short_label+' - '+this.props.yourFiles[item].created_at}>
                                        </SharedLabel>
                                    </FileSubheading>
                                </FileHeading>
                            </File>
                        ))}
                    </FilesList>

                    <Pagination>
                        {this.props.paginationMeta ? (
                            <>
                            <PaginationRefresh
                                onClick={() => {this.props.pullFiles(false, this.props.paginationMeta.current_page)}}>Refresh
                                results</PaginationRefresh>
                            <Pages className="pagination-pages">
                                {this.props.paginationMeta.links.map((item, index) => (
                                    <>
                                    {(item.label == '...' || (index > 0 && (item.label !== '<' && item.label !== '>' && index <= item.label))) ? (
                                        <span index={index}
                                              className={this.props.paginationMeta.current_page - 1 == item.label || this.props.paginationMeta.current_page + 1 == item.label || item.active || item.label == '...' || index == 0 || index == 1 || index == 2 || item.label == this.props.paginationMeta.last_page || item.label == this.props.paginationMeta.last_page - 1 || item.label == this.props.paginationMeta.last_page - 2 ? 'visible pagination-page-wrapper' : 'pagination-page-wrapper'}
                                              key={index}>
                                        <Page className="pagination-page"
                                              onClick={() => {this.props.pullFiles(false, item.label);}}
                                              active={item.active}>{item.label}</Page>
                                        </span>
                                    ) : (
                                        <>
                                        {(index == 0) ? (


                                            <span index={index}
                                                  className={'visible pagination-page-wrapper'}
                                                  key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullFiles(false, this.props.paginationMeta.current_page == 1 ? 1 : this.props.paginationMeta.current_page - 1);}}>
                                                {"<"}
                                            </PageArrow>
                                            </span>
                                        ) : (

                                            <span index={index}
                                                  className={'visible pagination-page-wrapper'}
                                                  key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullFiles(false, this.props.paginationMeta.current_page == this.props.paginationMeta.last_page ? this.props.paginationMeta.last_page : this.props.paginationMeta.current_page + 1);}}>
                                                {">"}
                                            </PageArrow>
                                            </span>
                                        )}
                                        </>
                                    )}
                                    </>
                                ))}
                            </Pages>
                            </>
                        ) : (
                            <></>
                        )}
                    </Pagination>
                </TabContent>
            </FileMenuWrapper>
        );
    }
}
